export default "__VITE_ASSET__rfd8NHYv__"